module.exports = __webpack_public_path__ + "img/pic_1.88ed2b11.png";